import { SSF$Date, WindowWithXlsx } from '../models/xlsx.model';

declare var window: WindowWithXlsx;

export function padNumber(value, length: number = 2): string {
  const zeros = '0'.repeat(length);
  const newValue = `${zeros}${value}`;
  return newValue.slice(newValue.length - length);
}

export function parseDateStringToExcelDate(dateString: string): number {
  const dateList: number[] = dateString.split('/').reverse().map(i => +i);
  const jsTimestamp = new Date(dateList[0], dateList[1], dateList[2]).getTime();
  return Math.round((jsTimestamp / (86400 * 1000)) + 25569);
}

export function parseXlsxDate(value: any): SSF$Date {
  const XLSX = window.XLSX;
  if (XLSX) {
    return typeof value === 'string'
      ? XLSX.SSF.parse_date_code(parseDateStringToExcelDate(value))
      : XLSX.SSF.parse_date_code(value);
  }
  console.warn('XLSX is not loaded yet');
  return null;
}

export function xlsxDateToDate(date: SSF$Date, time: SSF$Date): string {
  if (date && time) {
    const dateTime = `${date.y}-${padNumber(date.m)}-${padNumber(date.d)}T${padNumber(
      time.H
    )}:${padNumber(time.M)}:${padNumber(time.S)}`;
    const ksaDate = new Date(dateTime);
    ksaDate.setHours(ksaDate.getHours() - 3);
    return ksaDate.toLocaleString('en-US');
  }
  return null;
}
